import { DateType } from 'api/models';
import {
  TermSeparator,
  ValueSeparator,
} from 'components/organisms/tasks/filters/separators';
import { RoutePaths } from 'constant';

export const getProjectSpecificTimesheetReportUrl = (
  projectId: number,
  startDate: DateType,
  endDate: DateType,
): string =>
  `${RoutePaths.timesheetReports}/projects/${projectId}?range=custom${TermSeparator}${startDate}${ValueSeparator}${endDate}`;
